import React from "react";
import env from "../env";
import langData from "../lang-data";
import { useHistory, useParams } from "react-router-dom";
import { useApp } from "../state/app";
import { MODE } from "../config/consts";
import scorm from "../services/scorm";

console.log({ MODE });

let lastFetchedProjectID: string = "";

export default function useAppLogic() {
  const languageSelected = useApp((state) => state.languageSelected);
  const language = useApp((state) => state.language);
  const scenes = useApp((state) => state.scenes);
  const setScenes = useApp((state) => state.setScenes);
  const appText = useApp((state) => state.appText);
  const setAppText = useApp((state) => state.setAppText);
  const appTitle = useApp((state) => state.appTitle);
  const setAppTitle = useApp((state) => state.setAppTitle);
  const [langOptions, setLangOptions] = React.useState(langData);
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  const { projectID } = useParams<{ projectID: string }>();

  React.useEffect(() => {
    useApp.getState().setprojectID(projectID);
  }, [projectID]);

  React.useEffect(() => {
    if (MODE.startsWith("scorm")) return;
    const { setUserAnswers, setLanguageSelected, setLanguage, setDebriefIndex } =
      useApp.getState();
    if (localStorage.getItem(env.localStorage.language)) {
      setLanguage(JSON.parse(localStorage.getItem(env.localStorage.language)!));
    }
    if (localStorage.getItem(env.localStorage.userAnswer)) {
      setUserAnswers(
        JSON.parse(localStorage.getItem(env.localStorage.userAnswer)!),
      );
    }
    if (localStorage.getItem(env.localStorage.languageSelected)) {
      setLanguageSelected(
        JSON.parse(localStorage.getItem(env.localStorage.languageSelected)!),
      );
    }
    if (localStorage.getItem(env.localStorage.debriefIndex)) {
      setDebriefIndex(
        JSON.parse(localStorage.getItem(env.localStorage.debriefIndex)!) ?? 0,
      );
    }
    if (MODE.startsWith("web")) return;
    if (projectID !== lastFetchedProjectID) {
      lastFetchedProjectID = projectID;
      setLoading(true);
      fetch(`${env.apiEndpoint}/api/project-data/${projectID}`)
        .then((res) => res.json())
        .then((res) => {
          setLangOptions(res.data.locales);
          useApp.getState().setClient(res.data.client);
          useApp.getState().setVideoTranscript(res.data.videoTranscript);
          setAppText(res.data.appText);
          setScenes(res.data.scenes);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [history, projectID]);

  React.useEffect(() => {
    if (!MODE.startsWith("scorm")) return;

    if (!scorm.isConnected()) {
      // @todo: show some UI state to let the user know they're not connected to SCORM
      console.log("Not connected to SCORM");
      return;
    }

    const data = scorm.getData();
    const progress = scorm.getProgress();
    const status = scorm.getStatus();
    console.log("data", data);
    console.log("progress", progress);
    console.log("status", status);
    useApp.getState().setUserAnswers(data?.userAnswer ?? []);
    useApp.getState().setLanguageSelected(data?.languageSelected ?? false);
    useApp.getState().setDebriefIndex(data?.debriefIndex ?? 0);

    if (
      data?.sceneId &&
      history.location.pathname !== `/scene/${data?.sceneId}`
    ) {
      history.push(`/scene/${data?.sceneId}`);
    }

    function onHistoryChange(location: any) {
      if (!location.pathname.includes("scene")) return;
      const pathnameParts = location.pathname.split("/");
      const sceneId = pathnameParts[pathnameParts.length - 1];
      scorm.setData({ sceneId });
    }

    onHistoryChange(history.location);
    return history.listen(onHistoryChange);
  }, [projectID, history, scenes]);

  return {
    loading,
    scenes,
    appText,
    langOptions,
    languageSelected,
    language,
    appTitle,
    setAppTitle
  };
}
